import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSeoMeta } from '../hooks/useSeoMeta';
import { seoNotFoundPage } from '../seo/pages';
import { MarketingFooter } from '@/components/marketing/MarketingFooter';
import { MarketingSiteNavLinks } from '@/components/marketing/MarketingSiteNavLinks';
import { Button, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import './LandingPage.css';
import './PricingPage.css';
import './NotFoundPage.css';

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const navPrimaryLabel = user ? 'Открыть приложение' : loading ? '…' : 'Войти';

  useSeoMeta(seoNotFoundPage(pathname));

  const handleNavPrimaryCta = () => {
    if (loading) return;
    if (user) {
      navigate('/dashboard');
      return;
    }
    navigate('/auth');
  };

  return (
    <div className="landing-page cf-page not-found-page">
      <header className="cf-nav-wrap">
        <nav className="cf-nav">
          <Link to="/" className="cf-brand pricing-brand-link">
            preztimer
          </Link>
          <div className="cf-nav-links">
            <MarketingSiteNavLinks />
          </div>
          <div className="cf-nav-actions">
            <Button
              variant="cta"
              size="cta-sm"
              className="shrink-0"
              onClick={handleNavPrimaryCta}
              disabled={loading}
            >
              {navPrimaryLabel}
            </Button>
          </div>
        </nav>
      </header>

      <main className="cf-main pricing-page-main not-found-main">
        <section className="cf-section not-found-section">
          <p className="not-found-eyebrow">404</p>
          <h1>Страница не найдена</h1>
          <p className="not-found-lead">
            Такого адреса в preztimer нет. Проверьте ссылку или вернитесь на главную.
          </p>
          <div className="not-found-actions">
            <Link
              to="/"
              className={cn(buttonVariants({ variant: 'cta', size: 'cta' }), 'inline-flex w-full justify-center sm:w-auto')}
            >
              На главную
            </Link>
            <Link
              to="/features"
              className={cn(
                buttonVariants({ variant: 'outline', size: 'cta-md' }),
                'inline-flex w-full justify-center sm:w-auto',
              )}
            >
              Возможности
            </Link>
          </div>
        </section>
      </main>

      <div className="not-found-footer">
        <MarketingFooter />
      </div>
    </div>
  );
}
